import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { APP_RESET } from '../actions/actionTypes';
import { onSessionEnded } from '../domain/Auth';
import { growthbook } from '../growthbook';
import PosthogService from '../services/posthog/PosthogService';
import { clearPosthogIdentifyCache } from '../utils/posthog/identify';

/**
 * Everything a session leaves behind, cleared every time one ends — logout, a
 * refused refresh, another tab logging out, a new build. One list for every
 * way out, so none of them forgets something the others clear.
 *
 * Nothing of the previous admin survives into the next sign-in: no cached
 * query, no redux slice (`APP_RESET` returns each to its initial state), no
 * analytics identity (PostHog is reset and forgets every admin it was told
 * about, since a session ended at boot has no admin loaded to name).
 */
export const useSessionTeardown = () => {
  const store = useStore();
  const queryClient = useQueryClient();

  useEffect(
    () =>
      onSessionEnded(() => {
        clearPosthogIdentifyCache();
        PosthogService.getInstance().reset();
        growthbook.setAttributes({});
        queryClient.clear();
        store.dispatch({ type: APP_RESET });
      }),
    [store, queryClient],
  );
};

export default useSessionTeardown;
